module.exports = __webpack_public_path__ + "img/4.402d3a1d.png";